var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Grid, IconButton, TextField, Typography, styled, useMediaQuery } from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid-premium';
import { t } from 'i18next';
import { memo, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import Webcam from 'react-webcam';
import { UploadImage } from '../../../api/api';
import { Config } from '../../../api/config';
import { AudioFrameIcon, BackFrontCamera, BlackBackFrontCamera, BlueMikeIconDisabled, BluePauseIconNew, DeleteButtonNewIcon, MicIconBlue } from '../../../assets/images';
import { ESABoxParent, FreeTextMaxLength, LOCAL_STORAGE_KEYS, Module, isModuleConfig } from '../../../constants';
import { downloadAttachment, showLoader, showNotification } from '../../../redux/commonSlice';
import { getByIdAPI, getListAPI, setState } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { convertBlobToWav, formatTime, GoogleAnlyticsErrorLog, isExeOrJsFile, sortImagesByTimeStamp } from '../../../utils/utils';
import { MuiButton } from '../../atoms/buttonComponent';
import { MuiIconButton } from '../../atoms/iconButtonComponent';
import { MuiImagePopUp } from '../../atoms/imageDialogBox';
import { MuiStack } from '../../atoms/stackComponent';
import { AudioPlayer } from '../../molecules/audioComponent';
import { MuiPopup } from '../../molecules/popupComponent';
import { MuiLoaderButton } from '../../atoms/loaderButton';
import SkeletonLoader from '../../atoms/sketeton';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { Buffer } from "buffer";
var Img = styled("img")(function (_ref) {
    var theme = _ref.theme;
    return {
        height: "20px",
        width: "20px"
    };
});
var TranslateToJobMessage = function (props) {
    var _values$imageList, _values$imageList2, _values$imageList3, _values$audio4, _values$audio$audioBl, _values$audio5;
    var isOpen = props.isOpen, onClickMsgIcon = props.onClickMsgIcon, data = props.data, handleDataBack = props.handleDataBack, isFromVehicleDetails = props.isFromVehicleDetails, customerComplaintId = props.customerComplaintId, parentModuleDocumentId = props.parentModuleDocumentId, apiRequestParam = props.apiRequestParam, apiRequestPayload = props.apiRequestPayload, parentComponent = props.parentComponent, RoadTestId = props.RoadTestId, isViewOnly = props.isViewOnly, isFromJobCard = props.isFromJobCard, isEditable = props.isEditable, createAndEditFlow = props.createAndEditFlow, IsFromParentAPt = props.IsFromParentAPt;
    var dispatch = useAppDispatch();
    var id = useParams().id;
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var _a = useAppSelector(function (state) { return state.crud; }), preDocumentFetch = _a.preDocumentFetch, getStoredSAComment = _a.getStoredSAComment;
    var _b = useState(false), isCaptureEnable = _b[0], setCaptureEnable = _b[1];
    var fileInputRef = useRef(null);
    var webcamRef = useRef(null);
    var _c = useState(false), isPlaying = _c[0], setIsPlaying = _c[1];
    var _d = useState(0), audioDuration = _d[0], setAudioDuration = _d[1];
    var _e = useState(null), stream = _e[0], setStream = _e[1];
    var mediaRecorder = useRef(null);
    var _f = useState([]), audioChunks = _f[0], setAudioChunks = _f[1];
    var _g = useState(false), isDrawerOpen = _g[0], setISDrawerOpen = _g[1];
    var _h = useState([]), removedImages = _h[0], setRemovedImages = _h[1];
    var _j = useState(false), isCommentBoxEmpty = _j[0], setIsCommentBoxEmpty = _j[1];
    var _k = useState(false), isShowSkeleton = _k[0], setShowSkeleton = _k[1];
    var _l = useState(""), imageURL = _l[0], setImageURL = _l[1];
    var _m = useState('environment'), facingMode = _m[0], setFacingMode = _m[1];
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up('lg'); });
    var medium = useMediaQuery('(min-width:830px) and (max-width:1024px)');
    var CreatedFlow = (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isEstimate) === 'Create' || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isAppointment) === 'Create' || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isInspection) === 'Create';
    var UpdateFlow = (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isEstimate) === 'Update' || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isAppointment) === 'Update' || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isInspection) === 'Update';
    var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    var getUrl = "";
    var DownloadAttachmentUrl = "";
    var uploadAttachmentUrl = "";
    if (parentComponent === ESABoxParent.CustomerComplaint) {
        if (isFromJobCard) {
            getUrl = "".concat(Config.baseURL, "JobCardCustomerVoice/").concat(customerComplaintId, "/SAComments");
        }
        else {
            getUrl = "".concat(Config.baseURL, "CustomerVoice/").concat(customerComplaintId, "/SAComments");
        }
        DownloadAttachmentUrl = "".concat(Config.baseURL, "resource/CustomerVoice/");
        uploadAttachmentUrl = "".concat(Config.baseURL, "resource/CustomerVoice/").concat(customerComplaintId);
    }
    else if (parentComponent === ESABoxParent.RoadTest) {
        getUrl = "".concat(Config.baseURL, "RoadTest/").concat(RoadTestId, "/SARoadTestComments");
        DownloadAttachmentUrl = "".concat(Config.baseURL, "resource/RoadTest/");
        uploadAttachmentUrl = "".concat(Config.baseURL, "resource/RoadTest/").concat(RoadTestId);
    }
    var _o = useState({
        imageList: [],
        description: "",
        audio: {
            audioBlobUrl: '',
            audioFile: ''
        }
    }), values = _o[0], setValues = _o[1];
    var videoConstraints = {
        facingMode: facingMode,
        screenshotQuality: 0.2
    };
    var switchCamera = function () {
        setFacingMode(function (prevFacingMode) { return prevFacingMode === 'user' ? 'environment' : 'user'; });
    };
    useEffect(function () {
        if (apiRequestParam && parentModuleDocumentId && customerComplaintId && !IsFromParentAPt) {
            getSABoxData();
        }
    }, []);
    useEffect(function () {
        var _preDocumentFetch$dat;
        if ((preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat = preDocumentFetch.data) === null || _preDocumentFetch$dat === void 0 ? void 0 : _preDocumentFetch$dat.length) > 0 && !isEditable) {
            var key = preDocumentFetch.data[0].PreJobCardDocumentName;
            if (getStoredSAComment !== null && getStoredSAComment !== void 0 && getStoredSAComment.description) {
                getStoreValueSAComment();
            }
            else {
                getSABoxData();
            }
        }
    }, [preDocumentFetch]);
    useEffect(function () {
        if (getStoredSAComment !== null && getStoredSAComment !== void 0 && getStoredSAComment.description) {
            getStoreValueSAComment();
        }
    }, [createAndEditFlow]);
    useEffect(function () {
        var interval;
        if (isPlaying) {
            var startTime_1 = Date.now();
            interval = setInterval(function () {
                setAudioDuration(Math.floor((Date.now() - startTime_1) / 1000));
            }, 1000);
        }
        return function () {
            clearInterval(interval);
        };
    }, [isPlaying]);
    var getStoreValueSAComment = function () {
        var _getStoredSAComment$i, _getStoredSAComment$a, _getStoredSAComment$a2, _getStoredSAComment$a3, _getStoredSAComment$a4;
        setValues(_objectSpread(_objectSpread({}, values), {}, {
            description: getStoredSAComment === null || getStoredSAComment === void 0 ? void 0 : getStoredSAComment.description,
            imageList: (_getStoredSAComment$i = getStoredSAComment === null || getStoredSAComment === void 0 ? void 0 : getStoredSAComment.imageList) !== null && _getStoredSAComment$i !== void 0 ? _getStoredSAComment$i : [],
            audio: {
                audioBlobUrl: (_getStoredSAComment$a = getStoredSAComment === null || getStoredSAComment === void 0 || (_getStoredSAComment$a2 = getStoredSAComment.audio) === null || _getStoredSAComment$a2 === void 0 ? void 0 : _getStoredSAComment$a2.audioBlobUrl) !== null && _getStoredSAComment$a !== void 0 ? _getStoredSAComment$a : '',
                audioFile: (_getStoredSAComment$a3 = getStoredSAComment === null || getStoredSAComment === void 0 || (_getStoredSAComment$a4 = getStoredSAComment.audio) === null || _getStoredSAComment$a4 === void 0 ? void 0 : _getStoredSAComment$a4.audioFile) !== null && _getStoredSAComment$a3 !== void 0 ? _getStoredSAComment$a3 : ''
            }
        }));
    };
    var getSABoxData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _responseData$payload, _responseData$payload2, _responseData$payload3, responseData, _responseData$payload4, _responseData$payload5, _responseData$payload6, attachmentTobeDownload, imageAttachementURLs_1, audioAttachementURLs, imageAttachmentsUrlWithMediaType1_1, audioAttachmentsUrlWithMediaType2_1, downloadImagePromise, downloadAudioPromise, sortedImages, _responseData$payload7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setShowSkeleton(true);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: '',
                            url: getUrl
                        }))];
                case 2:
                    responseData = _a.sent();
                    if (!(responseData !== null && responseData !== void 0 && (_responseData$payload = responseData.payload) !== null && _responseData$payload !== void 0 && _responseData$payload.success && responseData !== null && responseData !== void 0 && (_responseData$payload2 = responseData.payload) !== null && _responseData$payload2 !== void 0 && _responseData$payload2.data && responseData !== null && responseData !== void 0 && (_responseData$payload3 = responseData.payload) !== null && _responseData$payload3 !== void 0 && (_responseData$payload3 = _responseData$payload3.data) !== null && _responseData$payload3 !== void 0 && _responseData$payload3.SAComments)) return [3 /*break*/, 7];
                    setShowSkeleton(false);
                    if (!((responseData === null || responseData === void 0 || (_responseData$payload4 = responseData.payload) === null || _responseData$payload4 === void 0 || (_responseData$payload4 = _responseData$payload4.data.SAComments) === null || _responseData$payload4 === void 0 || (_responseData$payload4 = _responseData$payload4.SABoxAttachments) === null || _responseData$payload4 === void 0 ? void 0 : _responseData$payload4.length) > 0)) return [3 /*break*/, 5];
                    attachmentTobeDownload = responseData === null || responseData === void 0 || (_responseData$payload5 = responseData.payload) === null || _responseData$payload5 === void 0 || (_responseData$payload5 = _responseData$payload5.data.SAComments) === null || _responseData$payload5 === void 0 ? void 0 : _responseData$payload5.SABoxAttachments;
                    imageAttachementURLs_1 = [];
                    audioAttachementURLs = [];
                    imageAttachmentsUrlWithMediaType1_1 = [];
                    audioAttachmentsUrlWithMediaType2_1 = [];
                    attachmentTobeDownload.map(function (element, index) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            if (element.MediaType === 1) {
                                imageAttachmentsUrlWithMediaType1_1.push(element);
                            }
                            if (element.MediaType === 2) {
                                audioAttachmentsUrlWithMediaType2_1.push(element);
                            }
                            return [2 /*return*/];
                        });
                    }); });
                    downloadImagePromise = imageAttachmentsUrlWithMediaType1_1.map(function (imageItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var base64, error_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 3, , 4]);
                                    if (!imageItem.AttachmentId) return [3 /*break*/, 2];
                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, parentComponent === ESABoxParent.CustomerComplaint ? customerComplaintId : RoadTestId, DownloadAttachmentUrl)];
                                case 1:
                                    base64 = _a.sent();
                                    imageAttachementURLs_1.push({
                                        blobUrl: base64,
                                        AttachmentId: imageItem.AttachmentId,
                                        isAlreadyUploaded: true,
                                        _ts: imageItem._ts
                                    });
                                    _a.label = 2;
                                case 2: return [3 /*break*/, 4];
                                case 3:
                                    error_1 = _a.sent();
                                    console.log("error", error_1);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    downloadAudioPromise = audioAttachmentsUrlWithMediaType2_1.map(function (imageItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var base64, error_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 3, , 4]);
                                    if (!imageItem.AttachmentId) return [3 /*break*/, 2];
                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, parentComponent === ESABoxParent.CustomerComplaint ? customerComplaintId : RoadTestId, DownloadAttachmentUrl)];
                                case 1:
                                    base64 = _a.sent();
                                    audioAttachementURLs.push({
                                        audioBlobUrl: base64,
                                        AttachmentId: imageItem.AttachmentId,
                                        isAlreadyUploaded: true
                                    });
                                    _a.label = 2;
                                case 2: return [3 /*break*/, 4];
                                case 3:
                                    error_2 = _a.sent();
                                    console.log("error", error_2);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(downloadImagePromise)];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, Promise.all(downloadAudioPromise)];
                case 4:
                    _a.sent();
                    sortedImages = sortImagesByTimeStamp(imageAttachementURLs_1);
                    setValues(_objectSpread(_objectSpread({}, values), {}, {
                        description: responseData === null || responseData === void 0 || (_responseData$payload6 = responseData.payload) === null || _responseData$payload6 === void 0 || (_responseData$payload6 = _responseData$payload6.data) === null || _responseData$payload6 === void 0 || (_responseData$payload6 = _responseData$payload6.SAComments) === null || _responseData$payload6 === void 0 ? void 0 : _responseData$payload6.Comments,
                        imageList: sortedImages,
                        audio: audioAttachementURLs.length > 0 ? audioAttachementURLs[0] : null
                    }));
                    return [3 /*break*/, 6];
                case 5:
                    setValues(_objectSpread(_objectSpread({}, values), {}, {
                        description: responseData === null || responseData === void 0 || (_responseData$payload7 = responseData.payload) === null || _responseData$payload7 === void 0 || (_responseData$payload7 = _responseData$payload7.data) === null || _responseData$payload7 === void 0 || (_responseData$payload7 = _responseData$payload7.SAComments) === null || _responseData$payload7 === void 0 ? void 0 : _responseData$payload7.Comments,
                        imageList: [],
                        audio: null
                    }));
                    _a.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    setShowSkeleton(false);
                    setValues(_objectSpread(_objectSpread({}, values), {}, {
                        description: "",
                        imageList: [],
                        audio: null
                    }));
                    _a.label = 8;
                case 8: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
                case 9:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var openCamera = function () {
        setCaptureEnable(true);
    };
    var openFileInput = function (e) {
        e.preventDefault();
        if (fileInputRef !== null && fileInputRef !== void 0 && fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    var uploadAttachmentUsingId = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, UploadImage("".concat(uploadAttachmentUrl), data, 'BlankSystemName', dispatch)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    }); };
    var createAttachmentId = function (custId, data) { return __awaiter(void 0, void 0, void 0, function () {
        var _values$audio, _SAResult$payload, ImageAttachmentsBody_1, audioFiles, upsertData_1, _values$imageList$fil, _audioFiles$filter, uploadPromises, uploadPromises1, requestBody, SAResult, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 6, , 8]);
                    ImageAttachmentsBody_1 = [];
                    if ((values === null || values === void 0 ? void 0 : values.imageList.length) > 0) {
                        values === null || values === void 0 || values.imageList.map(function (imageItem) {
                            if (!imageItem.isAlreadyUploaded) {
                                ImageAttachmentsBody_1.push({
                                    SystemName: "CustomerVoiceWiseComment",
                                    MediaType: 1
                                });
                            }
                        });
                    }
                    audioFiles = values !== null && values !== void 0 && (_values$audio = values.audio) !== null && _values$audio !== void 0 && _values$audio.audioBlobUrl ? [values === null || values === void 0 ? void 0 : values.audio] : [];
                    if (audioFiles.length > 0) {
                        audioFiles.map(function (audioFile) {
                            ImageAttachmentsBody_1.push({
                                SystemName: "CustomerVoiceWiseComment",
                                MediaType: 2
                            });
                        });
                    }
                    upsertData_1 = [];
                    if (!(ImageAttachmentsBody_1.length > 0)) return [3 /*break*/, 3];
                    uploadPromises = values === null || values === void 0 || (_values$imageList$fil = values.imageList.filter(function (f) { return !f.isAlreadyUploaded; })) === null || _values$imageList$fil === void 0 ? void 0 : _values$imageList$fil.map(function (imageItem, index) { return __awaiter(void 0, void 0, void 0, function () {
                        var formData, result;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    formData = new FormData();
                                    formData.append('data', imageItem === null || imageItem === void 0 ? void 0 : imageItem.file);
                                    return [4 /*yield*/, uploadAttachmentUsingId(formData)];
                                case 1:
                                    result = _a.sent();
                                    if (result !== null && result !== void 0 && result.statusCode && result !== null && result !== void 0 && result.statusCode) {
                                        upsertData_1.push({
                                            AttachmentId: result === null || result === void 0 ? void 0 : result.attachmentId,
                                            SystemName: "CustomerVoiceWiseComment",
                                            MediaType: 1
                                        });
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(uploadPromises)];
                case 1:
                    _a.sent();
                    uploadPromises1 = audioFiles === null || audioFiles === void 0 || (_audioFiles$filter = audioFiles.filter(function (f) { return !f.isAlreadyUploaded; })) === null || _audioFiles$filter === void 0 ? void 0 : _audioFiles$filter.map(function (audioItem, index) { return __awaiter(void 0, void 0, void 0, function () {
                        var formData, result;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    formData = new FormData();
                                    formData.append('data', audioItem === null || audioItem === void 0 ? void 0 : audioItem.audioFile);
                                    return [4 /*yield*/, uploadAttachmentUsingId(formData)];
                                case 1:
                                    result = _a.sent();
                                    if (result !== null && result !== void 0 && result.statusCode && result !== null && result !== void 0 && result.statusCode) {
                                        upsertData_1.push({
                                            AttachmentId: result === null || result === void 0 ? void 0 : result.attachmentId,
                                            SystemName: "CustomerVoiceWiseComment",
                                            MediaType: 2
                                        });
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(uploadPromises1)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    requestBody = _objectSpread(_objectSpread({}, apiRequestPayload), {}, {
                        SAComments: [{
                                ParentId: parentComponent === ESABoxParent.CustomerComplaint ? customerComplaintId : RoadTestId,
                                Comments: values.description,
                                ImageAttachments: upsertData_1
                            }]
                    });
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: '',
                            url: "".concat(Config.baseURL).concat(apiRequestParam, "/UpsertSAComments"),
                            request: requestBody
                        }))];
                case 4:
                    SAResult = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 5:
                    _a.sent();
                    if (SAResult !== null && SAResult !== void 0 && (_SAResult$payload = SAResult.payload) !== null && _SAResult$payload !== void 0 && _SAResult$payload.success) { }
                    onClickMsgIcon();
                    return [3 /*break*/, 8];
                case 6:
                    e_1 = _a.sent();
                    console.log(e_1);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 7:
                    _a.sent();
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); }; //Create Attachment API
    var handleConfirmClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _values$audio2, _values$audio3, deletePromise, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    if (!(CreatedFlow || (Module == isModuleConfig.Product ? UpdateFlow : false))) return [3 /*break*/, 1];
                    dispatch(setState({
                        key: "getStoredSAComment",
                        value: _objectSpread(_objectSpread({}, getStoredSAComment), {}, {
                            description: values.description,
                            audio: {
                                audioBlobUrl: values === null || values === void 0 || (_values$audio2 = values.audio) === null || _values$audio2 === void 0 ? void 0 : _values$audio2.audioBlobUrl,
                                audioFile: values === null || values === void 0 || (_values$audio3 = values.audio) === null || _values$audio3 === void 0 ? void 0 : _values$audio3.audioFile
                            },
                            imageList: values.imageList
                        })
                    }));
                    onClickMsgIcon();
                    return [3 /*break*/, 4];
                case 1: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
                case 2:
                    _a.sent();
                    deletePromise = removedImages.map(function (imageItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var request, DeleteAttchementResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!imageItem.isAlreadyUploaded) return [3 /*break*/, 2];
                                    request = {
                                        SystemName: "CustomerVoiceWiseComment",
                                        ParentId: parentComponent === ESABoxParent.CustomerComplaint ? customerComplaintId : RoadTestId,
                                        AttachmentId: imageItem.AttachmentId,
                                        PreJobCardDocumentId: id
                                    };
                                    return [4 /*yield*/, dispatch(getListAPI({
                                            key: "",
                                            url: "".concat(Config.baseURL, "PreJobCardDocumentAttachment/DeleteSAAttachment"),
                                            request: request
                                        }))];
                                case 1:
                                    DeleteAttchementResponse = _a.sent();
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(deletePromise)];
                case 3:
                    _a.sent();
                    createAttachmentId("", values === null || values === void 0 ? void 0 : values.imageList);
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    error_3 = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    console.error("Error fetching compagin List:", error_3);
                    return [2 /*return*/, []];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleTextField = function (event) {
        var complaintDescription = event.target.value;
        setValues(_objectSpread(_objectSpread({}, values), {}, {
            description: complaintDescription
        }));
        if (complaintDescription.length != 0) {
            setIsCommentBoxEmpty(true);
        }
    };
    function dataURLtoFile(dataurl, filename) {
        var _arr$;
        var arr = dataurl.split(','), mime = (_arr$ = arr[0]) === null || _arr$ === void 0 || (_arr$ = _arr$.match(/:(.*?);/)) === null || _arr$ === void 0 ? void 0 : _arr$[1], bstr = atob(arr[arr.length - 1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {
            type: mime
        });
    }
    var capture = function () {
        var _webcamRef$current;
        var imageSrc = (_webcamRef$current = webcamRef.current) === null || _webcamRef$current === void 0 ? void 0 : _webcamRef$current.getScreenshot();
        if (imageSrc) {
            var updatedComplaintList = __spreadArray([], values.imageList, true);
            var convertedFile = dataURLtoFile(imageSrc, "image-".concat(new Date().toISOString(), ".png"));
            var imageSizeInBytes = convertedFile.size;
            if (imageSizeInBytes > 5 * 1024 * 1024) {
                GoogleAnlyticsErrorLog(profileData, 'ClientSide', t("File size exceeds 5 MB. Please choose a smaller file"));
                dispatch(showNotification({
                    isOpen: true,
                    message: t("File size exceeds 5 MB. Please choose a smaller file"),
                    type: "error"
                }));
                return; // Do not proceed further
            }
            updatedComplaintList.push({
                blobUrl: imageSrc,
                file: convertedFile
            });
            setValues(_objectSpread(_objectSpread({}, values), {}, {
                imageList: updatedComplaintList
            }));
            setCaptureEnable(false);
        }
    };
    var handleFileChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var _e$target, allowedExtensions, _i, _a, file, extension, fileSizeInMB, arrayBuffer, buffer, error_4, updatedPhotosList, error_5;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 7, , 8]);
                    // Check if files exist
                    if (!((_e$target = e.target) !== null && _e$target !== void 0 && _e$target.files) || e.target.files.length === 0) {
                        return [2 /*return*/];
                    }
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    allowedExtensions = ['.png', '.jpeg', '.jpg'];
                    _i = 0, _a = e.target.files;
                    _b.label = 1;
                case 1:
                    if (!(_i < _a.length)) return [3 /*break*/, 6];
                    file = _a[_i];
                    extension = ".".concat(file.name.split('.').pop().toLowerCase());
                    // Check file extension
                    if (!allowedExtensions.includes(extension)) {
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', t("Only PNG, JPEG, JPG files are allowed."));
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("Only PNG, JPEG, JPG files are allowed."),
                            type: "error"
                        }));
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        e.target.value = '';
                        return [2 /*return*/];
                    }
                    fileSizeInMB = file.size / 1024 / 1024;
                    if (fileSizeInMB >= 5) {
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', t("File size exceeds 5 MB. Please choose a smaller file"));
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("File size exceeds 5 MB. Please choose a smaller file"),
                            type: "error"
                        }));
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        e.target.value = '';
                        return [2 /*return*/];
                    }
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, file.arrayBuffer()];
                case 3:
                    arrayBuffer = _b.sent();
                    buffer = Buffer.from(new Uint8Array(arrayBuffer));
                    if (isExeOrJsFile(buffer)) {
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("The file format is invalid and not allowed."),
                            type: "error"
                        }));
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        e.target.value = '';
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_4 = _b.sent();
                    console.error('Error processing file:', error_4);
                    dispatch(showNotification({
                        isOpen: true,
                        message: t("Error processing file. Please try again."),
                        type: "error"
                    }));
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    e.target.value = '';
                    return [2 /*return*/];
                case 5:
                    _i++;
                    return [3 /*break*/, 1];
                case 6:
                    updatedPhotosList = __spreadArray([], values.imageList, true);
                    updatedPhotosList.push({
                        file: e.target.files[0],
                        blobUrl: URL.createObjectURL(e.target.files[0])
                    });
                    setValues(_objectSpread(_objectSpread({}, values), {}, {
                        imageList: updatedPhotosList
                    }));
                    // Clear input
                    if (fileInputRef.current) {
                        fileInputRef.current.value = '';
                    }
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [3 /*break*/, 8];
                case 7:
                    error_5 = _b.sent();
                    console.error('Error in handleFileChange:', error_5);
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    dispatch(showNotification({
                        isOpen: true,
                        message: t("An error occurred while processing the file."),
                        type: "error"
                    }));
                    if (fileInputRef.current) {
                        fileInputRef.current.value = '';
                    }
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var onClickRemovePhotoIcon = function (items, photoIndex) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedPhotoList, imageItemToDelete, updatedImagesToRemove;
        return __generator(this, function (_a) {
            updatedPhotoList = __spreadArray([], values.imageList, true);
            imageItemToDelete = updatedPhotoList[photoIndex];
            if (imageItemToDelete && imageItemToDelete.AttachmentId) {
                updatedImagesToRemove = __spreadArray([], removedImages, true);
                updatedImagesToRemove.push(imageItemToDelete);
                setRemovedImages(updatedImagesToRemove);
            }
            updatedPhotoList.splice(photoIndex, 1);
            if (updatedPhotoList.length != 0) {
                setIsCommentBoxEmpty(true);
            }
            setValues(_objectSpread(_objectSpread({}, values), {}, {
                imageList: updatedPhotoList
            }));
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            return [2 /*return*/];
        });
    }); };
    var startRecording = function () {
        navigator.mediaDevices.getUserMedia({
            audio: true
        }).then(function (stream) {
            setStream(stream);
            // create media recorder instance to initialize recording
            mediaRecorder.current = new MediaRecorder(stream);
            if (stream) {
                setIsPlaying(true);
                var containers = ['webm', 'ogg', 'mp4', 'x-matroska', '3gpp', '3gpp2', '3gp2', 'quicktime', 'mpeg', 'aac', 'flac', 'wav'];
                var supportedAudios = containers.map(function (format) { return "audio/".concat(format); }).filter(function (item) { return MediaRecorder.isTypeSupported(item); });
                if (supportedAudios.length > 0) {
                    var media = new MediaRecorder(stream, {
                        mimeType: supportedAudios[0]
                    });
                    mediaRecorder.current = media;
                    //invokes the start method to start the recording process
                    mediaRecorder.current.start();
                    var localAudioChunks_1 = [];
                    mediaRecorder.current.ondataavailable = function (event) {
                        if (typeof event.data === "undefined")
                            return;
                        if (event.data.size === 0)
                            return;
                        localAudioChunks_1.push(event.data);
                    };
                    setAudioChunks(localAudioChunks_1);
                }
                else {
                    GoogleAnlyticsErrorLog(profileData, 'ClientSide', 'Audio not supported by browser');
                    dispatch(showNotification({
                        isOpen: true,
                        message: "Audio not supported by browser",
                        type: "error"
                    }));
                }
            }
        }).catch(console.error);
    };
    var stopRecording = function () {
        setIsPlaying(false);
        //stops the recording instance
        if (mediaRecorder && mediaRecorder.current && mediaRecorder.current.state === 'recording') {
            setIsPlaying(false);
            mediaRecorder.current.stop();
            mediaRecorder.current.onstop = function () { return __awaiter(void 0, void 0, void 0, function () {
                var audioBlob, convertedBlob, audioUrl, blobUrl;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            audioBlob = new Blob(audioChunks, {
                                type: 'audio/mp4'
                            });
                            return [4 /*yield*/, convertBlobToWav(audioBlob)];
                        case 1:
                            convertedBlob = _a.sent();
                            audioUrl = URL.createObjectURL(audioBlob);
                            blobUrl = URL.createObjectURL(convertedBlob);
                            fetch(blobUrl).then(function (response) { return response.blob(); }).then(function (blob) {
                                // Create a new File object from the Blob
                                var mp3File = new File([blob], "audio-".concat(new Date().toISOString(), ".mp3"), {
                                    type: 'audio/mpeg'
                                });
                                setValues(_objectSpread(_objectSpread({}, values), {}, {
                                    audio: {
                                        audioBlobUrl: audioUrl,
                                        audioFile: mp3File
                                    }
                                }));
                            }).catch(function (error) { return console.error('Error fetching Blob:', error); });
                            setAudioChunks([]);
                            return [2 /*return*/];
                    }
                });
            }); };
        }
        ;
    };
    var handleClickImage = function (url) {
        setImageURL(url);
        setISDrawerOpen(true);
    };
    var handleClose = function (photoIndex) {
        setImageURL("");
        setISDrawerOpen(false);
    };
    var onDeleteClick = function (AudioAttachmentId) {
        setValues(_objectSpread(_objectSpread({}, values), {}, {
            audio: {
                audioBlobUrl: '',
                audioFile: ''
            }
        }));
        setAudioDuration(0);
        if (AudioAttachmentId) {
            var request = {
                SystemName: "CustomerVoiceWiseComment",
                ParentId: parentComponent === ESABoxParent.CustomerComplaint ? customerComplaintId : RoadTestId,
                AttachmentId: AudioAttachmentId,
                PreJobCardDocumentId: id
            };
            dispatch(getListAPI({
                key: "",
                url: "".concat(Config.baseURL, "PreJobCardDocumentAttachment/DeleteSAAttachment"),
                request: request
            }));
        }
    };
    var handleCancelPopup = function () {
        stopRecording();
        props.setIsOpen(false);
        onClickMsgIcon();
    };
    var handlePopUpClose = function () {
        stopRecording();
        onClickMsgIcon();
    };
    var disableSABox = function () {
        if (Module == isModuleConfig.Bajaj) {
            if (isViewOnly || isFromJobCard) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            if (isEditable) {
                return false;
            }
            else {
                if (preDocumentFetch !== null && preDocumentFetch !== void 0 && preDocumentFetch.data && preDocumentFetch.data.length > 0 && preDocumentFetch.data[0].PreJobCardDocumentId || isViewOnly || isFromJobCard) {
                    console.log("I msnhdbhcgeh");
                    return true;
                }
                else {
                    return false;
                }
            }
        }
    };
    return /*#__PURE__*/ React.createElement(MuiPopup, {
        showLoaderOnPopup: true,
        openPopup: isOpen,
        title: t("Add comments")
        // subTitle={t("Please add comments with photos and audio")}
        // subTitleVariant='h4'
        // subTitleColor ={"#8593A3"}
        ,
        variant: "h1",
        onClose: handlePopUpClose,
        closeIcon: true
        // paddingTop='10px'
        ,
        containerStyle: {
            "&.MuiDialogContent-root": {
                padding: "0px",
                width: isDesktop ? 'calc(40vw)' : medium ? 'calc(60vw)' : lgMode ? 'calc(72vw)' : 'calc(90vw)'
            }
        }
    }, !isShowSkeleton && /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 3,
        direction: 'column',
        paddingX: 2,
        paddingBottom: 3
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        sx: {
            color: "#8593A3"
        }
    }, t("Please add comments with photos and audio"))), /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            border: '1px solid #DEE4EB',
            borderRadius: "8px",
            padding: '2px'
        },
        width: "100%"
    }, /*#__PURE__*/ React.createElement(TextField, {
        id: "multiline-input",
        placeholder: t("Enter comments"),
        value: values === null || values === void 0 ? void 0 : values.description,
        multiline: true,
        rows: 4,
        variant: "outlined",
        fullWidth: true,
        onChange: handleTextField,
        sx: {
            "& fieldset": {
                border: 'none'
            }
        },
        disabled: disableSABox() || isFromVehicleDetails,
        inputProps: {
            maxLength: FreeTextMaxLength
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 2
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "camera-btn",
        name: t('Camera'),
        size: "medium",
        style: {
            border: '1px solid #DEE4EB'
        },
        fullWidth: true,
        onClick: openCamera,
        disabled: disableSABox() || isFromVehicleDetails || ((_values$imageList = values.imageList) === null || _values$imageList === void 0 ? void 0 : _values$imageList.length) >= 3
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        id: "gallary-btn",
        name: t('Gallery'),
        size: "medium",
        style: {
            border: '1px solid #DEE4EB'
        },
        fullWidth: true,
        onClick: openFileInput,
        disabled: disableSABox() || isFromVehicleDetails || ((_values$imageList2 = values.imageList) === null || _values$imageList2 === void 0 ? void 0 : _values$imageList2.length) >= 3
    })), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        alignItems: "center"
    }, (_values$imageList3 = values.imageList) === null || _values$imageList3 === void 0 ? void 0 : _values$imageList3.map(function (photoUrl, photoIndex) { /*#__PURE__*/ return React.createElement(Grid, {
        item: true,
        key: photoIndex,
        xs: 4,
        sm: 6,
        md: 6,
        lg: 6
    }, /*#__PURE__*/ React.createElement("div", {
        className: "1st",
        style: {
            position: 'relative',
            display: 'inline-block'
        }
    }, !disableSABox() && /*#__PURE__*/ React.createElement(GridCloseIcon, {
        id: "remove-img-btn",
        onClick: function () { return onClickRemovePhotoIcon(photoUrl.images, photoIndex); },
        sx: {
            position: 'absolute',
            zIndex: 1,
            right: 10,
            top: 8,
            backgroundColor: "white",
            height: '15px',
            width: '15px',
            borderRadius: 50
        }
    }), /*#__PURE__*/ React.createElement("img", {
        src: photoUrl === null || photoUrl === void 0 ? void 0 : photoUrl.blobUrl,
        alt: "Image ".concat(photoIndex + 1),
        style: {
            width: '90%',
            height: '100px',
            borderRadius: '15px',
            position: 'relative',
            objectFit: 'contain'
        },
        onClick: function () { return handleClickImage(photoUrl === null || photoUrl === void 0 ? void 0 : photoUrl.blobUrl); }
    }))); }))), isDrawerOpen && /*#__PURE__*/ React.createElement(MuiImagePopUp, {
        isOpen: isDrawerOpen,
        onClose: handleClose,
        image: imageURL
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1
    }, values !== null && values !== void 0 && (_values$audio4 = values.audio) !== null && _values$audio4 !== void 0 && _values$audio4.audioBlobUrl ? /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%'
    }, /*#__PURE__*/ React.createElement(AudioPlayer, {
        src: (_values$audio$audioBl = values === null || values === void 0 || (_values$audio5 = values.audio) === null || _values$audio5 === void 0 ? void 0 : _values$audio5.audioBlobUrl) !== null && _values$audio$audioBl !== void 0 ? _values$audio$audioBl : "",
        isSlider: true,
        audioDuration: audioDuration
    }), !disableSABox() && /*#__PURE__*/ React.createElement("img", {
        src: DeleteButtonNewIcon,
        alt: "gallery-disable",
        style: {
            width: '36px',
            height: '36px',
            marginLeft: '10px'
        },
        onClick: function () {
            var _values$audio6;
            return onDeleteClick(values === null || values === void 0 || (_values$audio6 = values.audio) === null || _values$audio6 === void 0 ? void 0 : _values$audio6.AttachmentId);
        }
    }))) : !isPlaying ? /*#__PURE__*/ React.createElement(MuiIconButton, {
        disabled: disableSABox(),
        onClick: startRecording
    }, /*#__PURE__*/ React.createElement(Img, {
        sx: {
            marginRight: "10px"
        },
        src: disableSABox() ? BlueMikeIconDisabled : MicIconBlue
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        color: disableSABox() ? "#6A7682" : "#005DAC"
    }, t("Record"))) : /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 3
    }, /*#__PURE__*/ React.createElement(Img, {
        onClick: stopRecording,
        src: BluePauseIconNew,
        alt: "audioplayicon"
    }), /*#__PURE__*/ React.createElement("img", {
        src: AudioFrameIcon,
        alt: "audioplayicon",
        width: "80px",
        height: "20px"
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        sx: {
            color: '#1B1D21'
        }
    }, formatTime(audioDuration)))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 2,
        marginTop: 10
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        loading: loader.isLoaderOpen,
        id: "confirm-btn",
        name: "Confirm",
        size: "medium",
        fullWidth: true,
        variant: "contained",
        onClick: handleConfirmClick,
        disabled: disableSABox() || isPlaying || isFromVehicleDetails || !values.description
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        id: "cancel-btn",
        name: t('Cancel'),
        size: "medium",
        fullWidth: true,
        disabled: isFromVehicleDetails,
        onClick: handlePopUpClose
    })))), isCaptureEnable && /*#__PURE__*/ React.createElement(MuiPopup, {
        openPopup: isCaptureEnable,
        borderRadius: 0,
        containerStyle: {
            padding: '0',
            width: isDesktop ? 'calc(40vw)' : medium ? 'calc(60vw)' : lgMode ? 'calc(72vw)' : 'calc(90vw)',
            heigth: '80vh'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            padding: '0px',
            overflow: 'hidden',
            width: isDesktop ? 'calc(40vw)' : medium ? 'calc(60vw)' : lgMode ? 'calc(72vw)' : 'calc(90vw)'
        }
    }, /*#__PURE__*/ React.createElement(Webcam, {
        audio: false,
        width: isDesktop ? 'calc(40vw)' : medium ? 'calc(60vw)' : lgMode ? 'calc(72vw)' : 'calc(90vw)',
        height: "80%",
        ref: webcamRef,
        screenshotFormat: "image/jpeg",
        videoConstraints: videoConstraints
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: "space-between",
        sx: {
            position: 'relative',
            margin: "0",
            padding: '10px',
            backgroundColor: 'white',
            width: isDesktop ? 'calc(40vw)' : medium ? 'calc(60vw)' : lgMode ? 'calc(72vw)' : 'calc(90vw)'
        }
    }, /*#__PURE__*/ React.createElement(IconButton, {
        id: "switch-camera-icon",
        onClick: switchCamera
    }, facingMode == "user" ? /*#__PURE__*/ React.createElement("img", {
        src: BlackBackFrontCamera,
        alt: "camera"
    }) : /*#__PURE__*/ React.createElement("img", {
        src: BackFrontCamera,
        alt: "camera"
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: "space-between",
        gap: '10px'
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "close-btn",
        name: t("Close"),
        onClick: function () { return setCaptureEnable(false); }
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        id: "capture-btn",
        name: t("Capture"),
        onClick: capture
    })))), /*#__PURE__*/ React.createElement("input", {
        id: "image-file-input",
        type: "file",
        ref: fileInputRef,
        style: {
            display: 'none'
        },
        onChange: handleFileChange,
        accept: "image/*"
    }), /*#__PURE__*/ React.createElement(React.Fragment, null, isShowSkeleton && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        style: {
            height: '400px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null))));
};
export default /*#__PURE__*/ memo(TranslateToJobMessage);
